module.exports = __webpack_public_path__ + "img/phonelink-ring.8a18e72d.gif";